import CustomTypography from "@/components/Typography/CustomTypography";

export default function OptionsCell({
  value,
  options,
}: {
  value: string;
  options: { value: string; label: string }[];
}) {
  const indexOfValue = options.findIndex((el) => el.value === value);
  return (
    <div className="text-nowrap">
      <CustomTypography as="span" weight={"light"}>
        {indexOfValue.toString() === "-1"
          ? "No data"
          : options[indexOfValue].label}
      </CustomTypography>
    </div>
  );
}
